import React from "react";
import { useTranslation } from "../context/LanguageContext";

interface LoadingStateProps {
  message?: string;
  className?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message,
  className = "",
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-center justify-center h-full min-h-64 p-8 ${className}`}
    >
      {/* Modern animated spinner */}
      <div className="relative mb-6">
        <div className="w-12 h-12 border-4 border-gray-200 dark:border-dark-700 border-t-primary-600 rounded-full animate-spin"></div>
        <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-r-primary-400 rounded-full animate-ping opacity-75"></div>
      </div>

      {/* Loading text with better typography */}
      <div className="text-center space-y-2">
        <p className="text-lg font-semibold text-gray-800 dark:text-dark-100">
          {message || t("common.loading")}
        </p>
        <p className="text-sm text-gray-500 dark:text-dark-400">
          Please wait while we fetch your data...
        </p>
      </div>

      {/* Animated dots */}
      <div className="flex space-x-1 mt-4">
        <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce"></div>
        <div
          className="w-2 h-2 bg-primary-500 rounded-full animate-bounce"
          style={{ animationDelay: "0.1s" }}
        ></div>
        <div
          className="w-2 h-2 bg-primary-500 rounded-full animate-bounce"
          style={{ animationDelay: "0.2s" }}
        ></div>
      </div>
    </div>
  );
};

export default LoadingState;
